import React, { useRef } from "react";
import { useDispatch } from "react-redux";
import Link from "next/link";
import { useRouter } from "next/router";
import { AppDispatch } from "@app/store/store";
import { isPrivateRoute } from "@features/auth/AuthCheck";
import { logoutUserSessions } from "@entities/auth";
import { useOutsideClick } from "@shared/lib/hooks/useOutsideClick";
import { RouterConfig } from "@shared/lib/routerConfig";
import { UserMenuProps } from "./types";
import classes from "./user-menu.module.scss";

export const UserMenu = ({ isCompany = false, close }: UserMenuProps) => {
    const router = useRouter();
    const ref = useRef<HTMLDivElement>(null);
    const dispatch = useDispatch<AppDispatch>();

    const profilePath = isCompany ? RouterConfig.PROFILE_COMPANY : RouterConfig.PROFILE;

    useOutsideClick(ref, close);

    const handleLogout = async (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        e.preventDefault();
        if (isPrivateRoute(router.pathname)) {
            await router.push(RouterConfig.MAIN);
        }
        await dispatch(logoutUserSessions()).unwrap();
    };

    return (
        <div ref={ref} className={classes["user-menu"]}>
            <ul className={classes["user-menu__list"]}>
                <li className={classes["user-menu__list-item"]}>
                    <Link className={classes["user-menu__link"]} href={profilePath}>
                        Профиль
                    </Link>
                </li>
                <li className={classes["user-menu__list-item"]}>
                    <Link className={classes["user-menu__link"]} href={RouterConfig.MY_ADS}>
                        Мои объявления
                    </Link>
                </li>
                {isCompany && (
                    <li className={classes["user-menu__list-item"]}>
                        <Link
                            className={classes["user-menu__link"]}
                            href={RouterConfig.PROFILE_DESCRIPTION}
                        >
                            Описание компании
                        </Link>
                    </li>
                )}
                <li className={classes["user-menu__list-item"]}>
                    <Link className={classes["user-menu__link"]} href={RouterConfig.FAVORITES}>
                        Избранное
                    </Link>
                </li>
                <li className={classes["user-menu__list-item"]}>
                    <Link
                        className={classes["user-menu__link"]}
                        href={RouterConfig.HISTORY_MY_REPORTS}
                    >
                        Отчеты
                    </Link>
                </li>
                <li className={classes["user-menu__list-item"]}>
                    <a
                        className={classes["user-menu__link"]}
                        href={RouterConfig.MAIN}
                        onClick={handleLogout}
                    >
                        Выйти
                    </a>
                </li>
            </ul>
        </div>
    );
};